import React from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFRadioProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    isRequired?: boolean;
    name: string;
    rules?: unknown;
    value?: string;
    disabled?: boolean;
    bodyStyle?: React.CSSProperties;
    onClick?: (event?: React.FormEvent<HTMLInputElement>) => void;
    onChange?: (event?: React.ChangeEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    defaultVal?: string;
    selected?: boolean;
    readOnly?: boolean;
    labelOnLeft?: boolean;
}

const RHFRadio = (props: IRHFRadioProps) => {
    if (props.labelOnLeft) {
        return (
            <div className="form-field" style={props.bodyStyle}>
                <label htmlFor={props.name} style={props.labelStyle}>{props.label}</label>
                <input
                    type="radio"
                    name={props.name}
                    id={props.name}
                    ref={props.register ? props.register(props.rules) : undefined}
                    className={`field-checkbox ${props.errors?.[props.name] ? 'error-field' : ''}`}
                    disabled={props.disabled || props.readOnly}
                    onClick={props.onClick}
                    onChange={props.onChange}
                    style={!!props.disabled || !!props.readOnly ? { verticalAlign: 'middle', cursor: 'not-allowed', ...props.style } : props.style}
                    checked={props.selected}
                    value={props.value}
                />
                <br />
                {props.errors?.[props.name] && <p className="error-message">{props.errors?.[props.name]?.message}</p>}
            </div>
        );
    } else {
        return (
            <div className="form-field" style={props.bodyStyle}>
                <input
                    type="radio"
                    name={props.name}
                    id={props.name}
                    ref={props.register ? props.register(props.rules) : undefined}
                    className={`field-checkbox ${props.errors?.[props.name] ? 'error-field' : ''}`}
                    disabled={props.disabled || props.readOnly}
                    onClick={props.onClick}
                    onChange={props.onChange}
                    style={!!props.disabled || !!props.readOnly ? { verticalAlign: 'middle', cursor: 'not-allowed', ...props.style } : props.style}
                    checked={props.selected}
                    value={props.value}
                />
                <label htmlFor={props.name} style={props.labelStyle}>{props.label}</label>
                <br />
                {props.errors?.[props.name] && <p className="error-message">{props.errors?.[props.name]?.message}</p>}
            </div>
        );
    }
};

export default RHFRadio;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFRadio.tsx